<app-sheet [open]="ota.updateAvailable()" (closed)="ota.dismiss()">
  <div class="flex flex-col items-center pb-1">
    <div class="mb-5 grid h-16 w-16 place-items-center rounded-full bg-accent-tint">
      <span class="material-icons-round text-[28px] text-accent">rocket_launch</span>
    </div>
    <h2 class="mb-2 text-center text-[18px] font-extrabold tracking-[-0.02em] text-ink">
      Mise à jour prête
    </h2>
    <p class="mb-6 text-center text-[14px] leading-[20px] text-muted">
      Une nouvelle version de l'application a été téléchargée. Redémarrez pour l'appliquer.
    </p>
    <button
      type="button"
      class="mb-2 flex h-12 w-full items-center justify-center rounded-btn bg-accent text-[15px] font-bold text-white transition-transform duration-150 active:scale-95"
      (click)="ota.applyAndReload()"
    >
      Redémarrer
    </button>
    <button
      type="button"
      class="w-full py-2 text-center text-[14px] font-medium text-muted active:text-ink-soft"
      (click)="ota.dismiss()"
    >
      Plus tard
    </button>
  </div>
</app-sheet>
